import CodingCardField from "@/components/CodingCardField";
import TD, { TopDownFormProps } from "@/components/forms/TopDownForm";
import { CodingModel } from "@/data-models/value-models/structs";
import {
  IHumanReadableCoding,
  codingToConcept,
} from "@/data-models/value-models/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { assert } from "superstruct";
import { IDateTimeObservationInputElement } from "./types";

type FieldValues = {
  coding: IHumanReadableCoding | null;
  dateType: "date" | "month" | "time" | "datetime-local";
  hideLabel: boolean;
};

interface PropertiesFormProps
  extends Omit<TopDownFormProps<FieldValues>, "onSubmit"> {
  valueSet?: string;
  onSubmit?: (values: Partial<IDateTimeObservationInputElement>) => void;
}
const DEFAULT_VALUES =
  "http://tiro.health/fhir/ValueSet/snomed-ct-auto-generated";
function PropertiesForm({
  defaultValues,
  onSubmit,
  valueSet = DEFAULT_VALUES,
}: PropertiesFormProps) {
  const { t } = useTranslation();
  const handleSubmit = useCallback(
    (values: FieldValues) => {
      const { coding } = values;
      assert(coding, CodingModel);
      const transformed = {
        code: codingToConcept(coding),
        dateType: values.dateType,
        hideLabel: values.hideLabel,
      };
      onSubmit && onSubmit(transformed);
    },
    [onSubmit]
  );

  return (
    <TD<FieldValues> onSubmit={handleSubmit} defaultValues={defaultValues}>
      {({ register, control }) => (
        <div>
          <CodingCardField
            name="coding"
            label="Code"
            valueSet={valueSet}
            control={control}
          />
          <TD.Option
            {...register("hideLabel")}
            label={t("hide-label")!}
            small
          />
          <TD.Field
            {...register("dateType")}
            InputComponent={TD.Select as any}
            label="Format"
            small
          >
            <option value="date">Date</option>
            <option value="month">Month</option>
            <option value="datetime-local">Date and time</option>
          </TD.Field>
          <TD.Submit small>Update quantity</TD.Submit>
        </div>
      )}
    </TD>
  );
}

export default PropertiesForm;
